import React from 'react';

import SvgIcon from './SvgIcon';

const BellwHandle = props => (
    <SvgIcon viewBox="0 0 24 25" {...props}>
        <path
            d="M4 11.5a8 8 0 1116 0V18a1.5 1.5 0 001.5 1.5h-19A1.5 1.5 0 004 18v-6.5zM12 .501v3M14.45 21.5a2.5 2.5 0 01-4.9 0M14.5 6.969A4.5 4.5 0 0117 11"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

BellwHandle.displayName = 'BellwHandleIcon';

export default BellwHandle;
